import axios from 'axios'
import Cookies from 'js-cookie'
import axiosCancel from 'axios-cancel'
import {Message} from "element-ui";
import {camelizeKeys, decamelizeKeys} from 'humps'
import store from '@/store'
import { resolveApiBaseUrl } from '@/utils/apiBaseUrl'

export {default as userApi} from '@/api/user'
export {default as reportApi} from '@/api/report'
export {default as projectApi} from '@/api/project'
export {default as productApi} from '@/api/product'

axiosCancel(axios, {
  debug: false // default
})
let instance = axios.create({
  baseURL: resolveApiBaseUrl()
})
instance.cancel = axios.cancel
/* const refresh = () => {
  const COOKIE_SUFFIX = process.env.COOKIE_SUFFIX
  const JWT_TOKEN = `JWT_TOKEN${COOKIE_SUFFIX}`
  let token = Cookies.get(JWT_TOKEN)
  let instance = axios.create({
    baseURL: resolveApiBaseUrl(),
    headers: {'Content-Type': 'application/json', 'Authorization': token}
  })
  return instance({
    method: 'get',
    url: `/v1/user/renewtoken`
  }).then(res => {
    store.commit('SET_TOKEN', res.data.data.token)
  }).catch(err => {
    console.log(err)
  })
} */
// refactor: 格式化axios参数，request参数驼峰转下划线，response下划线转驼峰
// https://medium.com/javascript-in-plain-english/configuring-a-camelcase-to-snake-case-parser-with-axios-9fa34fd3b16f

instance.interceptors.request.use(
  config => {
    /* let exp = store.state.login.exp || 0
    if (exp > 0) {
      if (0 < moment.unix(exp).diff(moment().utc(), 'days',true) && moment.unix(exp).diff(moment().utc(), 'days',true) < 1 ) {
        refresh()
      }
    } */

    const COOKIE_SUFFIX = process.env.VUE_APP_COOKIE_SUFFIX
    const JWT_TOKEN = `JWT_TOKEN${COOKIE_SUFFIX}`

    const jwt = Cookies.get(JWT_TOKEN)
    if (jwt) {
      // rest_framework_jwt 要求 Authorization: JWT <token>（见 JWT_AUTH_HEADER_PREFIX）
      config.headers.Authorization = `JWT ${jwt}`
    }
    store.state.loading = true
    if (config.headers['Content-Type'] === 'multipart/form-data') {
      console.log(config)
      return config
    }
    if (config.data) {
      config.data = decamelizeKeys(config.data)
    }
    if (config.params) {
      config.params = decamelizeKeys(config.params)
      console.log(config.params)
    }
    // for (let key in config.params) {
    //   if (config.params[key] === '' || config.params[key] === null || config.params[key] === undefined) {
    //     delete config.params[key]
    //   }
    // }
    for (let key in config.data) {
      if (config.data[key] === '' || config.data[key] === null || config.data[key] === undefined) {
        delete config.data[key]
      }
    }
    return config
  },

  error => {
    store.state.loading = false
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => {
    store.state.loading = false
    if (
      response.data &&
      response.headers['content-type'] === 'application/json'
    ) {
      response.data = camelizeKeys(response.data)
    }
      console.log('response', response)
      if (response.config.method !== 'get'){
          Message({
              message: "Successful",
              type: "success",
              duration: 3000,
              showClose: true
          })
      }
    return response.data
  },
  error => {
    console.log('error_response', error.response)
    let status = error.response.status;
    let message = error.response.data.msg || error.response.data.message || error.response.data || '参数错误'
    if (status === 400) {
      Message({
        message: message,
        type: "warning",
        duration: 3000,
        showClose: true
      })
    } else if (status === 401) {
      Message (
        {
          message: error.response.data.msg,
          type: "warning",
          duration: 2000,
          showClose: true
        }
      )
    } else if (status === 403) {
      Message (
        {
          message:"您没有权限操作",
          type:"error",
          duration: 6000,
          showClose: true
        }
      )

    } else if (error.response.status === 404) {
      Message({
        message: "接口不存在",
        type: "warning",
        duration: 3000,
        showClose: true
      })
    } else {
      const serverMsg = error.response.data && (
        error.response.data.msg || error.response.data.message
      )
      Message.error(serverMsg || "服务器内部错误")
    }
    return Promise.reject(error)
  }
)

export default instance
